export default "__VITE_ASSET__d1666229__"